import styles from './image-list.module.scss';
import MaterialImageList from '@mui/material/ImageList';
import MaterialImageListItem from '@mui/material/ImageListItem';
import MaterialImageListItemBar from '@mui/material/ImageListItemBar';
import { ReactNode } from 'react';

/* eslint-disable-next-line */
export interface ImageListProps {
  children: any,
  // classes?: object,
  cols?: number,
  // component?: any,
  gap?: number,
  rowHeight?: 'auto' | number,
  sx?: any,
  variant?: 'masonry' | 'quilted' | 'standard' | 'woven'
}

export interface ImageListItemProps {
  children: any,
  // classes?: object,
  cols?: number,
  // component?: any,
  rows?: number,
  sx?: any
}

export interface ImageListItemBarProps {
  actionIcon?: any,
  actionPosition?: 'left' | 'right',
  // classes?: object,
  // position?: 'below' | 'bottom' | 'top',
  subtitle?: ReactNode,
  // sx?: any,
  title?: ReactNode
}

export function ImageList(props: ImageListProps) {
  return (
    <MaterialImageList
      sx={props.sx}
      cols={props.cols}
      rowHeight={props.rowHeight}
      variant={props.variant}
      gap={props.gap}>
      {props.children as React.ReactElement}
    </MaterialImageList>
  );
}

export function ImageListItem(props: ImageListItemProps) {
  return (
    <MaterialImageListItem
      cols={props.cols}
      rows={props.rows}
      sx={props.sx}>
      {props.children}
    </MaterialImageListItem>
  );
}

export function ImageListItemBar(props: ImageListItemBarProps) {
  return (
    <MaterialImageListItemBar
      title={props.title}
      subtitle={props.subtitle}
      actionIcon={props.actionIcon}
      actionPosition={props.actionPosition}
    />
  );
}

export default ImageList;